var isObject = {exports: {}};

export { isObject as __module };
